export default __webpack_public_path__ + "static/media/GChurchillOpen.2c3bcccc.jpg";